// polyfills
import "@babel/polyfill";
import "@babel/polyfill/noConflict";
// styles
import "../scss/style.scss";
// imports
import "./_imports";

document.addEventListener("DOMContentLoaded", () => {
  new WOW(
    {
      boxClass: "wow",
      animateClass: "viewTitle",
      offset: 0,
      mobile: true,
      live: true,
    },
    {
      boxClass: "wow",
      animateClass: "rightTranslate",
      offset: 0,
      mobile: true,
      live: true,
    },
    {
      boxClass: "wow",
      animateClass: "leftTranslate",
      offset: 0,
      mobile: true,
      live: true,
    }
  ).init();

  const sliders = document.querySelectorAll(".swiper");

  if (sliders) {
    sliders.forEach((slider) => {
      const slides = slider.querySelectorAll(".swiper-slide");
      if (slides) {
        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const resize = () => {
                  let height = 0;
                  slider.style.setProperty("--slider-height", `100%`);
                  slides.forEach((slide) => {
                    if (slide.clientHeight > height) height = slide.clientHeight;
                  });
                  // slider.style.setProperty("--slider-height", `${height}px`);
                };
                resize();
                window.addEventListener("resize", resize);
                slides.forEach((slide) => {
                  if (!slide.classList.contains("not-auto-height")) {
                    slide.style.minHeight = "var(--slider-height)";
                  }
                });
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.5 }
        );
        observer.observe(slider);
      }
    });
  }
});
